import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { AdministrationUsersService } from '../../../../services/administration-users.service'

import { Subscription } from 'rxjs/Subscription'
import { UserModel } from '../../../../models/user.model'
import { AdministrationService } from '../../../../services/administration.service'
import { MatTableDataSource } from '@angular/material'
import { UserService } from '../../../../services/user.service'
import { fuseAnimations } from '../../../../../core/animations'
import { AdministrationModel } from '../../../../models/administration.model'
import { ResourceLoadingService } from '../../../../services/resource-loading.service'

@Component({
  selector: 'app-administration-users',
  templateUrl: './administration-users.component.html',
  styleUrls: ['./administration-users.component.scss'],
  animations: fuseAnimations,
})
export class AdministrationUsersComponent implements OnInit, OnDestroy {
  @Input()
  administration: AdministrationModel
  users: UserModel[]
  dataSource: any
  displayedColumns = ['id', 'name', 'email', 'role']

  constructor(
    private _administrationUsersService: AdministrationUsersService,
    private _userService: UserService,
    private _loadingService: ResourceLoadingService,
  ) {}

  ngOnInit() {
    this._loadingService.loading(true)
    this._administrationUsersService.list(this.administration).subscribe((users: UserModel[]) => {
      this.users = users
      this.dataSource = new MatTableDataSource(this.users)
      this._loadingService.loading(false)
    })
  }

  /**
   * Destroy
   */
  ngOnDestroy(): void {
    // this.onCurrentadministrationChanged.unsubscribe();
  }

  readUser(user: UserModel) {
    this._userService.setCurrentUser(user)
  }

  resendInvite(user: UserModel, event) {
    this._administrationUsersService.resendInvite(this.administration, user).subscribe()

    event.stopPropagation()
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/administrations/administration-details/administration-users/administration-users.component.ts